import React from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
//Material imports
import useTheme from "@mui/styles/useTheme";
import makeStyles from "@mui/styles/makeStyles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Menu from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
//Limitless imports
import { useExpertProfileContext, useAuthenticationContext } from "../../../expert";
import ProfileHeaderItem from "./profile-header-item/ProfileHeaderItem";
import AppInfoHeaderItem from "./app-info-header-item/AppInfoHeaderItem";
import AppHelpHeaderItem from "./app-help-header-item/AppHelpHeaderItem";
import Toast from "../toast/Toast";
import { createPortalURL, getPortalDetails } from "../../utils/PortalHelper";
import { POLICY_APP_INFO } from "../../utils/CommonPolicyConstants";
import { useNavigation } from "../../hooks/navigation/NavigationContext";
import { useNotificationContext } from "@limitless/common/hooks/notification/NotificationContext";
const useStyles = makeStyles(() => ({
  iconContainer: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center"
  },
  logo: {
    height: 36,
    paddingTop: 10,
    marginLeft: 15
  }
}));
const Header = ({
  renderSettingsDrawer,
  renderHeaderOptions = () => null,
  mode,
  helpDrawerAvailable
}) => {
  const {
    canUserAccess,
    profile
  } = useExpertProfileContext();
  const {
    navigate,
    toggleNavigationDrawer
  } = useNavigation();
  const {
    notification,
    clearNotification
  } = useNotificationContext();
  const {
    signOut
  } = useAuthenticationContext();
  const classes = useStyles();
  const theme = useTheme();
  const isManager = canUserAccess(POLICY_APP_INFO);
  const location = useLocation();
  const {
    portals,
    cmPortal
  } = getPortalDetails(isManager, canUserAccess);
  const handlePortalClicked = (portal, destinationSuffix) => {
    window.open(createPortalURL(portal, destinationSuffix), "_blank");
  };
  const handleSignOut = React.useCallback(() => {
    signOut();
    navigate("/");
  }, [profile]);
  return /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(AppBar, {
    position: "relative",
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React.createElement(Toolbar, {
    disableGutters: true
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    item: true,
    alignItems: "center",
    xs: 4,
    sm: 4,
    nowrap: "true",
    justifyContent: "flex-start"
  }, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "Menu Collapse/Expand",
    color: "inherit",
    className: classes.menuIcon,
    onClick: toggleNavigationDrawer,
    id: "navigationExpandButton",
    size: "large"
  }, /*#__PURE__*/React.createElement(Menu, null))), /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement("picture", null, /*#__PURE__*/React.createElement("source", {
    srcSet: theme.assets.logoImgWebp,
    type: "image/webp"
  }), /*#__PURE__*/React.createElement("img", {
    src: theme.assets ? theme.assets.logoImg : "",
    className: classes.logo
  })))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    item: true,
    xs: 8,
    sm: 8,
    alignItems: "center",
    nowrap: "true",
    justifyContent: "flex-end",
    spacing: 0
  }, renderHeaderOptions(navigate), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, isManager && /*#__PURE__*/React.createElement(AppInfoHeaderItem, null)), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, helpDrawerAvailable && /*#__PURE__*/React.createElement(AppHelpHeaderItem, {
    handleNavigate: navigate
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(ProfileHeaderItem, {
    portalList: portals,
    onPortalClicked: handlePortalClicked,
    handleSignOut: handleSignOut,
    mode: mode,
    crowdManagerPortal: cmPortal,
    renderSettingsDrawer: renderSettingsDrawer,
    handleSettingsNavigation: () => navigate("/settings")
  })))))), location.pathname !== "/settings" && /*#__PURE__*/React.createElement(Toast, {
    message: notification.title,
    onClose: clearNotification,
    open: notification.title !== "",
    variant: notification.variant,
    duration: notification.duration,
    payload: notification.payload
  })));
};
export default Header;
Header.propTypes = {
  renderHeaderOptions: PropTypes.func,
  renderSettingsDrawer: PropTypes.func,
  mode: PropTypes.string.isRequired,
  helpDrawerAvailable: PropTypes.bool
};